import { Link } from 'react-router-dom';
import { Breadcrumb, Form, Layout, Result, Space } from 'antd';

import { Hooks, PageLayout } from '@app/web-components';

import { useCreateProfile } from '../data';
import { useProfileForm } from '../libs';

export const CreatePage = () => {
  const create = useCreateProfile();
  const layoutContentProps = Hooks.useFormLayout();

  const { getCreateFormProps, getSuccessResultProps } = useProfileForm(create);

  return (
    <Space direction="vertical" style={{ overflow: 'auto' }}>
      <Breadcrumb
        style={{ margin: '16px 0' }}
        items={[
          { title: <Link to="/">Home</Link> },
          { title: <Link to="../">Profiles</Link> },
          { title: 'Create Profile' },
        ]}
      />
      <Layout.Content {...layoutContentProps}>
        <PageLayout.Title title="Create Profile" />
        {create.isSuccess ? (
          <Result {...getSuccessResultProps()} title="Successfully created a profile!" />
        ) : (
          <Form {...getCreateFormProps()} />
        )}
      </Layout.Content>
    </Space>
  );
};
